import React from 'react';
// Import the corresponding CSS file
import './ContactUs.css';

const ContactUs = () => {
    // Data for office locations, updated with the new main address
    const officesData = [
        {
            name: 'Land Air Travels (India)',
            addressLines: [
                'GF-3, Tourism Plaza, 6-3-869/A',
                'Greenlands, Begumpet,',
                'Hyderabad, Telangana 500016'
            ],
            icon: 'ri-map-pin-2-line'
        },
         {
             name: 'Land Air Travels LLC (USA)',
             addressLines: [
                 '19232 Golden Meadows Drive,',
                 'German Town, Maryland MD2087,',
                 'U.S.A'
             ],
             icon: 'ri-building-4-line'
         },
         {
             name: 'Land Air Travels LLC (OHIO)',
             addressLines: [
                 '12750 WESTCHESTER TRL NONE,',
                 'CHESTERLAND,',
                 'OH 44026, U.S.A'
             ],
             icon: 'ri-building-4-line'
         },
         {
             name: 'Land Air Travels Private Limited (UK)',
             addressLines: [
                 '209 Newbridge Road,',
                 'Bath BA1 3HH,',
                 'UK'
             ],
             icon: 'ri-building-4-line'
         }
    ];

    // Hero image for the contact page
    const heroStyle = {
        backgroundImage: `url('/assets/images/ContactUs.png')`,
    };

    return (
        <div className="main-content">
            <div className="contact-hero-section" style={heroStyle}>
                <div className="hero-overlay">
                    <div className="container text-center">
                        <h1 className="hero-heading">Contact Us</h1>
                        <p className="hero-subheading">We're here to help. Reach out to us anytime.</p>
                    </div>
                </div>
            </div>

            <div className="page-content">
                <div className="container">

                    {/* Top Contact Info Box - Updated */}
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="support-box text-center">
                                <i className="ri-customer-service-2-line support-icon"></i>
                                <h4>For Customer Support & Queries</h4>
                                <p className="mb-2">Get in touch with our dedicated support team.</p>
                                <div className="contact-details">
                                    <a href="mailto:support@landairtravels.com" className="support-link">
                                        <i className="ri-mail-line me-2"></i>support@landairtravels.com
                                    </a>
                                    <span className="contact-divider">|</span>
                                    <a href="tel:+917995331116" className="support-link">
                                        <i className="ri-phone-line me-2"></i>(+91) 7995331116
                                    </a>
                                     <span className="contact-divider">/</span>
                                     <a href="tel:+917995331116" className="support-link">
                                        7995331116
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Worldwide Offices Section */}
                    <div className="offices-section">
                        <h2 className="section-title">Our Office</h2>
                        <div className="row g-4 justify-content-center">
                            {officesData.map((office, index) => (
                                <div className="col-lg-6 col-md-8" key={index}>
                                    <div className="office-card h-100">
                                        <div className="office-icon">
                                            <i className={office.icon}></i>
                                        </div>
                                        <h5 className="office-name">{office.name}</h5>
                                        <address className="office-address">
                                            {office.addressLines.map((line, i) => (
                                                <span key={i}>{line}<br /></span>
                                            ))}
                                        </address>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Google Map Section - Updated */}
                    <div className="map-section">
                        <h2 className="section-title">Find Us On The Map</h2>
                        <div className="map-container">
                            <iframe 
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.533867720869!2d78.4551716!3d17.4341436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9a16ffffffff%3A0xe0ac70b267ec2468!2sLand%20Air%20Travels%20PVT.LTD.!5e0!3m2!1sen!2sin!4v1765778694060!5m2!1sen!2sin" 
                                width="100%" 
                                height="450" 
                                style={{ border: 0 }} 
                                allowFullScreen="" 
                                loading="lazy" 
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Location of BABA TRAVEL AND TOURISM"
                            ></iframe>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ContactUs;